<template>
  <el-dialog :visible.sync="showDialog" append-to-body class="dialog-customfeedback" title="" top="0" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleCloseDialog" :show-close="false">
    <div slot="title" class="dialog-title">
      <img class="img-feedback-title" src="@/assets/feedback_title.png" />
      <div class="title-btn-box">
        <div>期待您的声音！</div>
        <img class="icon-delete" src="@/assets/icon_deleted2.png" @click="handleCloseDialog" />
      </div>
      <div class="subtitle-box">您的意见和建议是对我们最大的支持！</div>
    </div>
    <el-form ref="form" :model="formData">
      <el-form-item prop="mid_table_remark_001" label-width="0" :rules="rules.mid_table_remark_001">
        <el-input class="feedback-cont" type="textarea" v-model="formData.mid_table_remark_001" placeholder="每条反馈我们都会认真看，请尽可能描述详细......" :autosize="false" maxlength="400" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="custom-button btn-ff3333 btn-submit" @click="handleSubmitFeedback">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import pageCommon from "@/utils/pagecommon";
import feedbackApi from "@/api/feedback";

export default {
  name: "CustomFeedback",
  mixins: [],
  data() {
    return {
      showDialog: false,
      formData: {
        mid_table_remark_001: ""
      },
      rules: {
        mid_table_remark_001: [
          { required: true, message: "填写反馈内容", trigger: "blur" },
        ],
      },
      isRequesting: false,
    };
  },
  computed:{
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  mounted() {
    let _this = this;

  },
  methods: {
    handleSubmitFeedback:function(){
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      _this.$refs["form"].validate((valid) => {
        if (valid) {
          _this.handleSubmitMain();
        } else {
          _this.isRequesting = false;
        }
      });
      //_this.showDialog=false;
    },
    handleSubmitMain: function () {
      let _this = this;
      let requestData = {
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_001: _this.formData.mid_table_remark_001,
        mid_table_remark_002:201,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(feedbackApi, "submitFeedBack", requestData)
        .then(
          (res) => {
            _this.isRequesting = false;
            _this.$message.success("提交成功");
            _this.handleCloseDialog();
          },
          (err) => {
            console.log(err,"err")
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    handleCloseDialog:function(){
      let _this=this;
      _this.formData.mid_table_remark_001="";
      _this.$refs["form"].clearValidate();
      _this.showDialog=false;
    },

  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-customfeedback {
  /deep/.el-dialog {
    position: absolute;
    width: 876px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 876px;
      height: 130px;
      background: #fff1f1;
      border-radius: 4px 4px 0px 0px;
      padding: 32px 34px;
      box-sizing: border-box;
      text-align: left;
      overflow: hidden;
      .img-feedback-title {
        position: absolute;
        width: 169px;
        height: 116px;
        top: 14px;
        right: 84px;
      }
      .title-btn-box {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #313131;
        line-height: 32px;
        .icon-delete {
          position: relative;
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
      }
      .subtitle-box {
        position: relative;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #222222;
        line-height: 18px;
        margin-top: 18px;
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 34px 34px 0;
      box-sizing: border-box;
      .feedback-cont {
        position: relative;
        width: 100%;
        .el-textarea__inner {
          position: relative;
          width: 100%;
          height: 288px;
          background: #f4f4f4;
          border: 1px solid #eeeeee;
          border-radius: 4px;
          box-sizing: border-box;
          padding: 22px 17px;
          resize: none;

          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          line-height: 26px;
          &::placeholder {
            color: #c2c2c2;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #c2c2c2;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #c2c2c2;
          }

          &::-moz-placeholder {
            /* Mozilla Firefox 19+ 适配火狐 */
            color: #c2c2c2;
          }

          &:-ms-input-placeholder {
            /* Internet Explorer 10+  适配ie*/
            color: #c2c2c2;
          }
        }
      }
    }
    // .el-form-item {
    //   margin-bottom: 30px;
    // }
    .el-dialog__footer {
      position: relative;
      width: 100%;
      padding: 40px;
      box-sizing: border-box;
      text-align: center;
      .btn-submit {
        position: relative;
        width: 224px;
        height: 46px;
        line-height: 46px;
        text-align: center;

        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }

  // /deep/.dialog-footer {
  //   display: flex;
  //   justify-content: flex-end;
  //   .custom-button {
  //     width: 80px;
  //     height: 46px;
  //     line-height: 46px;

  //     font-size: 16px;

  //     margin-left: 25px;

  //     &:first-child {
  //       margin-left: 0;
  //     }
  //   }
  // }
}
</style>
